<template>
  <Cookies />
</template>

<script setup>
import Cookies from '@/sections/cookies/Cookies.vue';
</script>
